export default {"src":"/_next/static/media/pair-3.cc15786d.svg","height":309,"width":453,"blurWidth":0,"blurHeight":0};